import { render } from "./ThemeSelector.vue?vue&type=template&id=6a89a9bb"
import script from "./ThemeSelector.vue?vue&type=script&lang=js"
export * from "./ThemeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__